
//* plp Hero *//
document.addEventListener('DOMContentLoaded', function() {
    var subtitleWrapper = document.querySelectorAll('.plp-hero__subtitle-wrapper p, .plp-hero__subtitle-wrapper div, .plp-hero__subtitle-wrapper span');
    var readMoreBtn = document.querySelector('.plp-hero__read-more');
    var readMoreBtnText = document.querySelector('.plp-hero__read-more span');
    var isExpanded = false;
    if (subtitleWrapper && readMoreBtn) {
        readMoreBtn.addEventListener('click', function() {
            subtitleWrapper.forEach(function(p) {
                p.classList.toggle('open');
            });
            this.classList.toggle('open');
            isExpanded = !isExpanded;
            readMoreBtnText.textContent = isExpanded ? 'Read Less' : 'Read More';
        });
    }

    var subtitles = document.querySelectorAll('.plp-hero__subtitle-wrapper p, .plp-hero__subtitle-wrapper div, .plp-hero__subtitle-wrapper span');
    if (subtitles.length && readMoreBtn) {
        var shouldShowBtn = Array.from(subtitles).some(function(subtitle) {
            var lineHeight = parseFloat(getComputedStyle(subtitle).lineHeight);
            var maxHeight = lineHeight * 2;
            return subtitle.scrollHeight > maxHeight + 1;
        });
        if (shouldShowBtn) {
            readMoreBtn.style.display = '';
        }
    }

    var plpHero = document.querySelector('.plp-hero');
    if (plpHero) {
        var style = window.getComputedStyle(plpHero);
        document.querySelectorAll('.clp-slider-section').forEach(function(clpSliderSection) {
            clpSliderSection.style.marginLeft = style.marginLeft;
        });
    }

    document.querySelectorAll('.clp-slider-filters').forEach(filtersContainer => {
        const filterBtns = filtersContainer.querySelectorAll('.clp-slider-filter-btn');
        const sliderContainer = filtersContainer.closest('.clp-slider-container');
        const swipers = sliderContainer ? sliderContainer.querySelectorAll('.clp-slider-swiper') : [];
        filterBtns.forEach((btn, idx) => {
            btn.addEventListener('click', function() {
                filterBtns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                swipers.forEach((sw, i) => {
                    sw.style.display = (i === idx) ? 'block' : 'none';
                });

                sliderContainer.querySelectorAll('.clp-slider-swiper .swiper-container').forEach(swiperEl => {
                    if (swiperEl.swiper) {
                        swiperEl.swiper.slideTo(0, 0);
                    }

                    const allSlides = Array.from(swiperEl.querySelectorAll('.product-card-slide'));
                    const hiddenSlidesCount = allSlides.filter(card => card.classList.contains('hide-slide')).length;
                    const visibleSlidesCount = allSlides.length - hiddenSlidesCount;

                    if (swiperEl.swiper) {
                        swiperEl.swiper.updateSlides();
                    }
                });
            });
        });
    });

    document.querySelectorAll('.clp-slider-sub-filter-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            const container = this.closest('.clp-slider-container');
            const subFilterBtns = container.querySelectorAll('.clp-slider-sub-filter-btn');
            subFilterBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            let subfilter = btn.getAttribute('data-subfilter').toLowerCase();

            container.querySelectorAll('.clp-slider-swiper .product-card-slide').forEach(card => {
                const title = (card.getAttribute('data-category-subfilter') || '').toLowerCase();
                card.style.opacity = title.includes(subfilter) ? '' : '0';
                card.classList.toggle('hide-slide', !title.includes(subfilter));
                const content = card.querySelector('.product-card__content');
                if (content) {
                    content.style.display = title.includes(subfilter) ? '' : 'none';
                }
            });

            container.querySelectorAll('.clp-slider-swiper .swiper-container').forEach(swiperEl => {
                if (swiperEl.swiper) {
                    swiperEl.swiper.slideTo(0, 0);
                }

                const allSlides = Array.from(swiperEl.querySelectorAll('.product-card-slide'));
                const hiddenSlidesCount = allSlides.filter(card => card.classList.contains('hide-slide')).length;
                const visibleSlidesCount = allSlides.length - hiddenSlidesCount;

                if (swiperEl.swiper) {
                    swiperEl.swiper.updateSlides();
                }
            });
        });

        const container = btn.closest('.clp-slider-container');
        container.querySelectorAll('.swiper-slide #swatch-swiper-js').forEach(function(swiperEl) {
            new Swiper(swiperEl, {
            slidesPerView: 4,
            navigation: {
                nextEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-next'),
                prevEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-prev')
            },
            spaceBetween: 8,
             breakpoints: {
                768: { 
                    slidesPerView: 5
                },
                1280: { 
                    slidesPerView: 6
                },
                1499: { 
                    slidesPerView: 7
                }
            }
            });
        });
    });
});


 // Compare Table Navigation //
function compareTableNavigation() {
    const leftButton = document.querySelector('.js-compare-table-left');
    const rightButton = document.querySelector('.js-compare-table-right');
    const compareTable = document.querySelector('.compare-table');

    // Add check in to ensure the above elements exist
    if (!leftButton || !rightButton || !compareTable) return;

    leftButton.addEventListener('click', () => {
    const secondCell = compareTable.querySelector('td:nth-child(2)');
    const cellWidth = secondCell.offsetWidth;
    compareTable.scrollBy({ left: -cellWidth, behavior: 'smooth' });
    });

    rightButton.addEventListener('click', () => {
    const secondCell = compareTable.querySelector('td:nth-child(2)');
    const cellWidth = secondCell.offsetWidth;
    compareTable.scrollBy({ left: cellWidth, behavior: 'smooth' });
    });
}

compareTableNavigation();

/* View More Button */

document.addEventListener('DOMContentLoaded', function() {
    var loadMoreBtn = document.getElementById('load-more-products');
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener('click', function() {
        var nextPage = loadMoreBtn.getAttribute('data-next-page');
        var url = new URL(window.location.href);
        url.searchParams.set('page', nextPage);

        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = 'Loading...';

        fetch(url)
        .then(function(response) { return response.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('#collection-grid-list > .c-collection-grid__item');
            var gridList = document.getElementById('collection-grid-list');
            newItems.forEach(function(item) {
                gridList.appendChild(item);
            });

            // Update next page or hide button if no more pages
            var newBtn = doc.getElementById('load-more-products');
            if (newBtn && newBtn.hasAttribute('data-next-page')) {
                loadMoreBtn.setAttribute('data-next-page', newBtn.getAttribute('data-next-page'));
                loadMoreBtn.disabled = false;
                loadMoreBtn.textContent = 'View more';
            } else {
                loadMoreBtn.style.display = 'none';
            }
        })
        .catch(function() {
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'View more';
        });
        setTimeout(function() {
            document.querySelectorAll('.c-collection-grid__item #swatch-swiper-js').forEach(function(swiperEl) {
                new Swiper(swiperEl, {
                    slidesPerView: 4,
                    navigation: {
                        nextEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-next'),
                        prevEl: swiperEl.parentElement.querySelector('.swatch-swiper-button-prev')
                    },
                    spaceBetween: 4,
                    breakpoints: {
                        768: { 
                            slidesPerView: 5
                        },
                        1280: { 
                            slidesPerView: 6
                        },
                        1499: { 
                            slidesPerView: 7
                        }
                    }
                });
            });
        }, 3000);
    });

    document.querySelectorAll('.js-size-guide-popup-trigger').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
            var sizeGuide = document.querySelector('.o-size-guide-wrapper');
            if (sizeGuide) {
                sizeGuide.style.opacity = '1';
                sizeGuide.style.visibility = 'inherit';
                sizeGuide.style.display = 'flex';
                sizeGuide.style.zIndex = '9999';
            }
        });
    });

    document.querySelectorAll('.js-size-guide-popup-close').forEach(function(closeBtn) {
        closeBtn.addEventListener('click', function() {
            var sizeGuide = document.querySelector('.o-size-guide-wrapper');
            if (sizeGuide) {
                sizeGuide.style.opacity = '';
                sizeGuide.style.visibility = '';
                sizeGuide.style.display = '';
                sizeGuide.style.zIndex = '';
            }
        });
    });
});


console.log('Custom JS loaded');
// Footer js //
  (() => {
    document.querySelectorAll('.footer-summary').forEach(summary => summary.addEventListener('click', toggleFooterDetails))
  })()

  function toggleFooterDetails(e) {
    const elementSelector = e.target.dataset.target;
    if(!e.target.dataset.target) return;
    const target = document.querySelector(elementSelector);
    e.target.classList.toggle('open');
    target.classList.toggle('open');
  }

// Filter values //
  class MainFilterValue extends HTMLElement {
    connectedCallback() {
      const name = this.getAttribute('data-name');
      const value = this.getAttribute('data-value');
      this.innerHTML = this.innerHTML || '&times;';
      this.style.cursor = 'pointer';
      this.addEventListener('click', () => {
        const targetElement = document.querySelector(`[name="${name}"][value="${value}"]`);
        if (targetElement) {
          targetElement.click();
        } else {
          console.log(`Element with name="${name}" and value="${value}" not found.`);
        }
      });
    }
  }
  customElements.define('filter-value', MainFilterValue);

  // Fabric Group //
  function handleLinkedProductClick(event) {
    const currentElement = event.target;
    const linkedItem = currentElement.closest('linked-product');
    const fabricWrap = currentElement.closest('.pdp-main__fabric');
    const allColourWraps = document.querySelectorAll('.pdp-main__colour');
    const fabric = linkedItem.getAttribute('replace-to');
    const replaceFrom = linkedItem.getAttribute('replace-form');
    const colourWrap = document.querySelector(`.pdp-main__colour[data-fabric="${fabric}"]`);
    const form = currentElement.closest('.pdp-main__form');
    
    if (!form || !linkedItem || !fabricWrap || linkedItem.querySelector('a')) return;
    form.classList.add('all-unavailable');
    const titles = document.querySelectorAll('.pdp-main__title, .c-breadcrumbs__link--product');
    titles.forEach(title => {
    title.textContent = title.textContent.replace(replaceFrom, fabric);
    });

    const activeItem = fabricWrap.querySelector('.is-active');
    if (!activeItem) return;

    activeItem.classList.remove('is-active');
    linkedItem.classList.add('is-active');

    if (colourWrap) {
    allColourWraps.forEach((colourWrap) => colourWrap.classList.add('hidden'));
    colourWrap.classList.remove('hidden');
    document
        .querySelectorAll('.pdp-main__colour-radio-wrapper')
        .forEach((radioWraper) => radioWraper.classList.remove('is-active'));
    document
        .querySelectorAll('.c-color-status')
        .forEach((icon) => icon.classList.remove('c-color-select__icon-active'));
    document.querySelector('.js-product-add-to-cart').classList.add('hidden');
    }
  }

  window.onload = () => {
    document.querySelectorAll('linked-product').forEach((linkedProductElement) => {
    linkedProductElement.setExternalClickHandler(handleLinkedProductClick);
    });
  };

  // Main Cart Footer //
  document.addEventListener('DOMContentLoaded', function () {
    function isIE() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        const trident = ua.indexOf('Trident/');

        return (msie > 0 || trident > 0);
    }

    if (!isIE()) return;
    const cartSubmitInput = document.createElement('input');
    cartSubmitInput.setAttribute('name', 'checkout');
    cartSubmitInput.setAttribute('type', 'hidden');
    document.querySelector('#cart').appendChild(cartSubmitInput);
    document.querySelector('#checkout').addEventListener('click', function (event) {
        document.querySelector('#cart').submit();
    });
  });

  // Product Recommendations //

    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.quantity-decrement').forEach(function(btn) {
            btn.addEventListener('click', function() {
                const input = btn.parentNode.querySelector('input[type=number]');
                if (input) input.stepDown();
            });
        });
    });
    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.quantity-increment').forEach(function(btn) {
            btn.addEventListener('click', function() {
                const input = btn.parentNode.querySelector('input[type=number]');
                if (input) input.stepUp();
            });
        });
    });

    // Fabric Guide //
    document.addEventListener('DOMContentLoaded', function() {
      var btn = document.getElementById('fabric-guide-btn');
      var modal = document.getElementById('fabric-guide-popup');
      if (btn && modal && typeof modal.open === 'function') {
        btn.addEventListener('click', function() {
            modal.classList.toggle('hidden');
            modal.open();
        });
      }
    });

    //Transparent Nav Megamenu//

    window.addEventListener('scroll', function() {
        const megamenu = document.getElementById('shopify-section-megamenu');
        if (!megamenu) return;
        if (window.scrollY > 30) {
            megamenu.classList.add('has-scrolled');
        } else {
            megamenu.classList.remove('has-scrolled');
        }
    });

        //Megamenu active nav//

    function updateNavBackground() {
        const hasActiveDropdown = Array.from(document.querySelectorAll('.megamenu-dropdown.active')).length > 0;
        const nav = document.querySelector('.o-navigation.transparent');
        if (nav) {
            if (hasActiveDropdown) {
                nav.classList.add('hovered');
            } else {
                nav.classList.remove('hovered');
            }
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        document.querySelectorAll('.megamenu-dropdown').forEach(dropdown => {
            dropdown.addEventListener('mouseenter', function() {
                dropdown.classList.add('active');
                updateNavBackground();
            });
            dropdown.addEventListener('mouseleave', function() {
                dropdown.classList.remove('active');
                updateNavBackground();
            });
            document.querySelectorAll('.c-announcement-bar').forEach(bar => {
                bar.addEventListener('mouseenter', updateNavBackground);
                bar.addEventListener('mouseleave', updateNavBackground);
            }); 
            updateNavBackground();
        });
    });